import { createSelector } from 'reselect'

export const getEmployeeRoles = (state) => state?.employeeRole?.byEmployeeId ?? {}

export const getEmployeeRole = (state, employeeId) => state?.employeeRole?.byEmployeeId?.[employeeId] ?? {}

export const makeGetEmployeeRole = () => createSelector([getEmployeeRole], (employeeRole) => employeeRole)

export const getIsEmployeeRolesLoading = (state) => state?.employeeRole?.isLoading ?? false
